import {
	BodyL,
	PrimaryButton as DSPrimaryButton,
	Modal,
	ModalContent,
	ModalFooter,
	ModalTitle,
	ModalWrapper,
	SPACING,
} from '@monthio/design-system'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { tabManagerService } from './tabManagerService'

const StyledModalContent = styled(ModalContent)`
	display: flex;
	flex-direction: column;
	gap: ${SPACING.l};
	padding-block-start: calc(${SPACING.m} + 30px);
`

export const AccessibleOtherTabOpenedModal = () => {
	const [isOpened, setIsOpened] = useState(false)
	const { t } = useTranslation()

	useEffect(() => {
		const subscription = tabManagerService.currentTabActiveSubject.subscribe(
			(isActive) => {
				setIsOpened(isActive)
			},
		)
		return () => {
			subscription.unsubscribe()
		}
	}, [])

	return (
		<Modal isOpen={isOpened} onOpenChange={() => setIsOpened(false)}>
			<ModalWrapper>
				<StyledModalContent>
					<ModalTitle>{t('otherTabOpen-modal-title')}</ModalTitle>
					<BodyL>{t('otherTabOpen-modal-description')}</BodyL>
				</StyledModalContent>
				<ModalFooter>
					<DSPrimaryButton
						onClick={() => tabManagerService.setCurrentTabActive()}
					>
						{t('otherTabOpen-modal-btn-continueHere')}
					</DSPrimaryButton>
				</ModalFooter>
			</ModalWrapper>
		</Modal>
	)
}
